import { action, extendObservable } from 'mobx';
import FetchService from '../../../core/services/FetchService';
import ConfirmationDialogService from '../../../core/services/ConfirmationDialogService';
import NotificationService from '../../../core/services/NotificationService';
import qs from 'qs';
import { browserHistory } from 'react-router';
import FormService from '../../../core/services/FormService';

class VocabularyListService {
  fetch = new FetchService();
  form = new FormService();

  constructor() {
    extendObservable(this, {
      vocabularies: [],
      filter: {
        criteria: '',
        academicPlan: '',
      },
      pagination: {
        current: 1,
        total: 0,
        pageSize: 15,
      },
    });
  }

  init = action(() => {
    this.form.reset();
    const params = qs.parse(window.location.search.substring(1));
    if (params.page) {
      this.pagination.current = parseInt(params.page);
    }
    this.vocabularies = [];
    this.load(this.pagination);
  });

  load = action((page) => {
    if (page && page.current) {
      this.pagination.current = page.current;
    } else {
      this.pagination.current = 1;
    }

    this.fetch
      .fetch({
        apiVersion: 'v3',
        url: '/vocabularies',
        query: {
          expand: 'vocabularyTheme academicPlan',
          page: this.pagination.current,
          size: this.pagination.pageSize,
          ...(this.form.getValue('criteria') && {
            criteria: this.form.getValue('criteria'),
          }),
          ...(this.form.getValue('academicPlan') && {
            academicPlan: this.form.getValue('academicPlan'),
          }),
        },
      })
      .then(() => {
        if (this.fetch.data && this.fetch.data.docs) {
          this.pagination.total = this.fetch.data.total;
          this.vocabularies = this.fetch.data.docs;
          const params = qs.parse(window.location.search.substring(1));
          params.page = this.pagination.current;
          browserHistory.replace(`${window.location.pathname}?${qs.stringify(params)}`);
        } else {
          this.vocabularies = [];
        }
      });
  });

  handleRestore = action((vocabulary) => {
    ConfirmationDialogService.show(
      'Restore Vocabulary',
      `You are about to enable the Vocabulary "${vocabulary.text}", Do you want to continue ?`,
      () => {
        this.fetch
          .fetch({
            apiVersion: 'v3',
            url: `/vocabularies/${vocabulary.id}/restore`,
            method: 'patch',
          })
          .then(() => {
            if (this.fetch.data) {
              NotificationService.addNotification(`Vocabulary "${vocabulary.text}" enabled successfully.`, 'success');
              this.load();
            }
            if (this.fetch.error) {
              NotificationService.addNotification(this.fetch.error, 'error');
            }
          });
      }
    );
  });

  handleDisable = action((vocabulary) => {
    console.log(vocabulary);
    ConfirmationDialogService.show(
      'Delete Vocabulary',
      `You are about to disable the Vocabulary "${vocabulary.text}", Do you want to continue ?`,
      () => {
        this.fetch
          .fetch({
            apiVersion: 'v3',
            url: `/vocabularies/${vocabulary.id}/disable`,
            method: 'patch',
          })
          .then(() => {
            if (this.fetch.data) {
              NotificationService.addNotification(`Vocabulary "${vocabulary.text}" disabled successfully.`, 'success');
              this.load();
            }
            if (this.fetch.error) {
              NotificationService.addNotification(this.fetch.error, 'error');
            }
          });
      }
    );
  });
}

const vocabularyListService = new VocabularyListService();

export default vocabularyListService;
